<template>
  <!-- 大会直播 -->
  <div class="live-schedule">
    <Title class="pc" :title="global.config[global.area_id]['livevod']?'大会回放':'大会直播'" :description="description"></Title>
    <div class="wap_banner_schedule mob">
      <h1 class="sch_h1 sch_wap_h1">大会直播</h1>
      <p class="sch_p1"></p>
      <p class="sch_p">{{this.global.formatTime(startTime/1000,'Y.M.D')}}~{{this.global.formatTime(endTime/1000,'Y.M.D')}}</p>
    </div>
    <div class="mpd-content" :class="ispc?'pc':'mob'" v-if="Object.keys(groups).length == 0">
      <p class="load_word">{{load_word}}</p>
    </div>
    <slot v-else>
      <!-- pc -->
      <div class="mpd-content pc" v-if="ispc">
        <div class="list">
          <!-- 短标题+无开幕式： -->
          <div class="list-con">
            <div class="box"
                v-for="(item, index) in groups" :key="'live_group_' + index"
                :style="`width:${100/(Object.keys(groups).length)}%;`"
            > <div
                class="litem"
                :class="group == index-1 ? 'act' : ''"
                @click="setGroup($event, index-1, 'pc')"
              > <h1>{{item.groupName}}</h1>
              </div>
              <div
                class="litem"
                :class="group == index-1 ? 'act' : ''"
              > <p v-if="!getTime_('group_start',index-1) && getTime_('group_end',index-1)">正在直播</p>
                <p v-else-if="!getTime_('end')">直播结束</p>
                <p v-else>即将开始</p>
              </div>
            </div>
          </div>
        </div>
        <div class="courses">
          <div
            class="livebtn act"
            v-if="themeList[group] && themeList[group].length>0 && !getTime_('group_start',group) && getTime_('group_end',group)"
            @click="toLive(theTime>=endTime?(endTime/1000):(startTime/1000), group+1)"
          >直播中，点击进入直播间
          </div>
          <slot v-for="(item, index) in themeList[group]">
            <slot v-if="item.venueName!='开幕式'">
              <!-- 每Math.ceil(pro_times.length/2)=3个1行 -->
              <slot v-for="(line,lindex) in Math.ceil(pro_times.length/Math.ceil(pro_times.length/2))">
                <div
                  class="line"
                  v-if="themeList[group].length>1?index==lindex:1"
                  :key="'live_theme_' + index + '_' + lindex"
                >
                  <div class="left">
                    <div class="mark" v-if="isTime(item.date*1000, item.times.split(',')[0].split('-')[0], item.times.split(',')[item.times.split(',').length-1].split('-')[1])">
                      <img src="../assets/img/live_start.png" alt="">
                      <!-- <p class="await">即将开始</p>
                      <p class="start">直播中</p>
                      <p class="end">已结束</p> -->
                    </div>
                    <div class="box">
                      <h1>{{ item.venueName }}</h1>
                      <p>出品人：{{ item.name }}</p>
                    </div>
                  </div>
                  <div class="right">
                    <div class="rline">
                        <div
                          class="course"
                          v-for="(titem) in Math.ceil(pro_times.length/2)"
                          :key="'live_course_' + index + '_' + titem"
                          :style="`width: ${100/Math.ceil(pro_times.length/2)}%;`"
                        >
                          <slot v-for="(sitem, sindex) in item.schedulingCourse">
                            <div
                              class="box"
                              v-if="pro_times[lindex*Math.ceil(pro_times.length/2)+titem-1] && pro_times[lindex*Math.ceil(pro_times.length/2)+titem-1]==sitem.startTime && sitem.date==((lindex*Math.ceil(pro_times.length/2)+titem-1)<Math.ceil(pro_times.length/2)?startTime/1000:endTime/1000)"
                              :key="'schedulingCourse_'+index+'_'+titem+'_'+(lindex*Math.ceil(pro_times.length/2)+sindex)"
                              :style="Math.ceil(pro_times.length/2)<=3?'max-width:260px;':''"
                            >
                              <h2 @click="toLive(sitem.date, group+1)">
                                《{{ sitem.courseTitle }}》
                              </h2>
                              <p class="time"><i class="glyphicon glyphicon-time"></i> {{global.formatTime(sitem.date,'M.D')}} {{sitem.startTime}}-{{sitem.endTime}}</p>
                              <p @click="toLive(sitem.date, group+1)">
                                {{ sitem.name }} {{ sitem.company }} {{ sitem.position }}
                              </p>
                            </div>
                          </slot>
                          <div class="box none" v-if="pro_times[lindex*3+titem-1]">
                            <h1>敬请期待</h1>
                          </div>
                        </div>
                      </div>
                  </div>
                </div>
              </slot>
              <!-- old -->
              <div
                class="line"
                v-if="item.venueName!='开幕式'"
                :key="'live_theme_' + index"
                style="display:none;"
              >
                <div class="left">
                  <div class="mark" v-if="isTime(item.date*1000, item.times.split(',')[0].split('-')[0], item.times.split(',')[item.times.split(',').length-1].split('-')[1])">
                    <img src="../assets/img/live_start.png" alt="">
                    <!-- <p class="await">即将开始</p>
                    <p class="start">直播中</p>
                    <p class="end">已结束</p> -->
                  </div>
                  <div class="box">
                    <h1>{{ item.venueName }}</h1>
                    <p>出品人：{{ item.name }}</p>
                  </div>
                </div>
                <!-- .right -->
                <div class="right">
                  <div class="rline">
                    <!-- MPD课程专题设置与giac不同，大部分专题会持续两天 -->
                    <slot v-if="themeList[group].length==1">
                      <div
                        class="course"
                        v-for="(titem, cindex) in pro_times"
                        :key="'live_course_' + index + '_' + cindex"
                        :style="`width: ${100/pro_times.length}%;`"
                      >
                        <slot v-for="(sitem, sindex) in item.schedulingCourse">
                          <div
                            class="box"
                            v-if="titem==sitem.startTime && sitem.date==(cindex<Math.ceil(pro_times.length/2)?startTime/1000:endTime/1000)"
                            :key="'schedulingCourse_'+index+'_'+cindex+'_'+sindex"
                          >
                            <h2 @click="toLive(sitem.date, group+1)">
                              《{{ sitem.courseTitle }}》
                            </h2>
                            <p class="time"><i class="glyphicon glyphicon-time"></i> {{global.formatTime(sitem.date,'M.D')}} {{sitem.startTime}}-{{sitem.endTime}}</p>
                            <!-- <p class="time"><i class="glyphicon glyphicon-time"></i> {{global.formatTime(sitem.date,'Y.M.D')}}</p>
                            <p class="time" style="margin-top:0;"><i class="glyphicon glyphicon-time" style="opacity:0;"></i> {{sitem.startTime}}-{{sitem.endTime}}</p> -->
                            <p @click="toLive(sitem.date, group+1)">
                              {{ sitem.name }} {{ sitem.company }} {{ sitem.position }}
                            </p>
                          </div>
                        </slot>
                        <div class="box none">
                          <h1>敬请期待</h1>
                        </div>
                      </div>
                    </slot>
                    <!-- 3357 有专题只进行一天 -->
                    <slot v-else-if="global.area_id=='3357'">
                      <div
                        class="course"
                        v-for="(titem, cindex) in (index==0 ? pro_times.slice(0,Math.ceil(pro_times.length/2)) : pro_times.slice(Math.ceil(pro_times.length/2),pro_times.length))"
                        :key="'live_course_' + index + '_' + cindex"
                        :style="`width: ${100/Math.ceil(pro_times.length/2)}%;`"
                      >
                        <slot v-for="(sitem, sindex) in item.schedulingCourse">
                          <div
                            class="box"
                            v-if="titem==sitem.startTime && sitem.date==(index==0?startTime/1000:endTime/1000)"
                            :key="'schedulingCourse_'+index+'_'+cindex+'_'+sindex"
                          >
                            <h2 @click="toLive(sitem.date, group+1)">
                              《{{ sitem.courseTitle }}》
                            </h2>
                            <p class="time"><i class="glyphicon glyphicon-time"></i> {{global.formatTime(sitem.date,'M.D')}} {{sitem.startTime}}-{{sitem.endTime}}</p>
                            <p @click="toLive(sitem.date, group+1)">
                              {{ sitem.name }} {{ sitem.company }} {{ sitem.position }}
                            </p>
                          </div>
                        </slot>
                        <div class="box none">
                          <h1>敬请期待</h1>
                        </div>
                      </div>
                      <div
                        class="course"
                        v-if="index>0&&Math.ceil(pro_times.length/2)*2>pro_times.length"
                        :style="`width: ${100/Math.ceil(pro_times.length/2)}%;`"
                      >
                        <div class="box none"></div>
                      </div>
                    </slot>
                  </div>
                </div>
              </div>
            </slot>
          </slot>
        </div>
      </div>
      <!-- mob 767px -->
      <div class="mpd-content mob" v-else>
        <!-- 标题文字对齐 -->
        <div class="top">
          <table
            v-for="line in Math.ceil(Object.keys(groups).length/menuCount)"
            :key="'groups_table_'+line"
            style="width: 100vw;margin-left: 0;margin-right: 0;"
          >
            <!-- :style="'width:'+swidth+20+'px;'"  -->
            <tr v-for="tr in 2" :key="'groups_table_'+line+'_tr_'+tr">
              <td v-for="num in menuCount"
                :key="'group_table_'+line+'_tr1_'+num"
                :class="group==(line-1)*menuCount+num-1 ? 'act' : ''"
                :style="`width:${(100/menuCount)}vw;`"
                @click="setGroup($event,(line-1)*menuCount+num-1,'mob')"
              >
                <div class="box" v-if="groups[(line-1)*menuCount+num]" :style="groups[(line-1)*menuCount+num] ? 'background-color:#FFFFFF;' : 'background-color:transparent;'">
                  <h1 v-if="tr==1">
                    {{groups[(line-1)*menuCount+num].groupName}}
                  </h1>
                  <slot v-else-if="tr==2">
                    <slot v-if="line==1 && num==1">
                      <p class="act" v-if="!getTime_('group_start',(line-1)*menuCount+num-1) && getTime_('group_end',(line-1)*menuCount+num-1)">正在直播</p>
                      <p v-else-if="getTime_('start',0)">即将开始</p>
                      <p v-else>直播结束</p>
                    </slot>
                    <slot v-else>
                      <p class="act" v-if="!getTime_('group_start',(line-1)*menuCount+num-1) && getTime_('group_end',(line-1)*menuCount+num-1)">正在直播</p>
                      <p v-else-if="!getTime_('end')">直播结束</p>
                      <p v-else>即将开始</p>
                    </slot>
                  </slot>
                </div>
              </td>
            </tr>
          </table>
        </div>
        <!-- collapse -->
        <div class="groups panel-group" id="live_groups" v-if="theme_cli_mob" :key="'groups_mob_'+theme_cli_mob">
          <div
            class="group panel panel-default"
            :class="['group_' + index, theme[group] == index ? 'act' : '']"
            v-for="(item, index) in themeList[group]"
            :key="'live_group_mob_' + index"
          >
            <!-- head -->
            <div class="group_head panel-heading"
                :class="theme[group] == index ? 'act' : ''"
                :id="'live_header_'+index"
                @click.prevent="theme[group]!=index ? theme[group]=index : theme[group]=-1, $forceUpdate()"
                data-toggle="collapse"
                :data-target="'#live_group_list_' + index"
                aria-expanded="false"
                :aria-controls="'live_group_list_' + index"
            >
              <h1>{{item.venueName}}</h1>
              <p class="act"
                 v-if="!getTime_('theme_start',index) && getTime_('theme_end',index)"
                 @click="toLive(theTime>=endTime?(endTime/1000):(startTime/1000), group+1)"
              >正在直播</p>
              <p v-else-if="!getTime_('theme_end',index)">直播结束</p>
              <p v-else>即将开始</p>
              <span :class="theme[group] == index ? 'open' : 'close'"></span>
            </div>
            <!-- body -->
            <div class="collapse panel-collapse" :id="'live_group_list_' + index" data-parent="#live_groups" :aria-labelledby="'live_header_'+index">
              <div
                class="group_detail panel-body"
                v-for="(titem, tindex) in item.schedulingCourse"
                :key="'live_group_mob_' + index + '_' + tindex"
              >
                <div class="group_course" @click="toLive(titem.date, group+1)">
                  <h2><i class="glyphicon glyphicon-time"></i> {{global.formatTime(titem.date,'M.D')}} {{titem.startTime}}-{{titem.endTime}}</h2>
                  <h1>{{titem.courseTitle}}</h1>
                  <p><span>{{titem.name}}</span> {{titem.compony}} {{titem.position}}</p>
                  <span class="act" v-if="!getTime_('course_start',index,tindex) && getTime_('course_end',index,tindex)">正在直播</span>
                  <span v-else-if="!getTime_('course_end',index,tindex)">直播结束</span>
                  <span v-else>即将开始</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </slot>
  </div>
</template>

<script>
/* eslint-disable one-var */
/* eslint-disable camelcase */
/* eslint-disable no-unused-vars */

export default {
  name: 'LiveSchedule',
  components: {
    Title: () => import('@/components/Title')
  },
  data () {
    let _this = this
    return {
      title: '大会直播',
      description: '',
      load_word: '加载中...',
      swidth: window.innerWidth,
      ispc: true,
      token: '',
      pro_times: _this.global.config[_this.global.area_id]['project_schedule_times'],
      groups: {},
      themeList: [],
      group: 0,
      theme: [],
      menuCount: 3,
      theme_cli_pc: false,
      theme_cli_mob: false,
      startTime: '',
      endTime: '',
      theTime: new Date().getTime(),
      timestamp: 24 * 60 * 60 * 1000
    }
  },
  created () {
    if (!this.global.config[this.global.area_id]['haslive'] && !this.global.config[this.global.area_id]['livevod']) {
      this.$router.push({path: '/home', query: {sid: this.global.area_id}})
    }
    // // },
    // // mounted() {
    this.token = localStorage.getItem('token') ? localStorage.getItem('token') : ''
    this.initsize()
    this.getGroups()
    this.getTheme()
  },
  methods: {
    initsize: function () {
      this.swidth = window.innerWidth
      if (this.swidth > 767) {
        this.ispc = true
        this.group = 0
        this.theme_cli_pc = true
        this.theme_cli_mob = false
      } else {
        this.ispc = false
        // this.group = -1;
        this.group = 0
        this.theme_cli_pc = false
        this.theme_cli_mob = true
      }
      // console.log(this.ispc, this.group);
      this.setresize()
    },
    setresize: function () {
      // this.swidth = window.innerWidth;
      window.addEventListener('resize', () => {
        let swidth = window.innerWidth
        // pc->mob || mob->mob
        if (
          (this.swidth > 767 && swidth <= 767) ||
          (this.swidth <= 767 && swidth <= 767)
        ) {
          this.ispc = false
          this.theme_cli_pc = false
          if (!this.theme_cli_mob) { this.group = 0 }
          // !this.theme_cli_mob ? this.group=-1 : "";
          this.theme_cli_mob = true
        }
        // mob->pc || pc->pc
        if (
          (this.swidth <= 767 && swidth > 767) ||
          (this.swidth > 767 && swidth > 767)
        ) {
          this.ispc = true
          this.theme_cli_mob = false
          if (!this.theme_cli_pc) { this.group = 0 }
          this.theme_cli_pc = true
        }
        // console.log(this.swidth, swidth, this.ispc, this.group, this.theme_cli_pc, this.theme_cli_mob);
        this.$forceUpdate()
      })
    },
    //
    getGroups: function () {
      this.$http
        .jsonp(this.global.url.schedule + this.global.area_id)
        .then(data => {
          return data.json()
        })
        .then(res => {
          // console.log(res);
          this.groups = {}
          if (res.errno && res.errno.toString() === '0') {
            this.startTime = Object.keys(res.data.datas)[0] * 1000
            this.endTime = Object.keys(res.data.datas)[1] * 1000
            let finishing = {...res.data.finishing}
            for (let day in finishing) {
              for (let group in finishing[day]) {
                // console.log(finishing[day][group].groupId, finishing[day][group].groupName);
                if (!this.groups[finishing[day][group].groupId]) {
                  this.groups[finishing[day][group].groupId] = finishing[day][group]
                }
              }
            }
            // console.log(this.groups);
            this.load_word = Object.keys(this.groups).length > 0 ? '加载中...' : '暂无直播'
          }
        })
    },
    getTheme: function () {
      this.$http
        .jsonp(this.global.url.project_new + this.global.area_id)
        .then(data => {
          return data.json()
        })
        .then(res => {
          // console.log(res.data);
          this.theme = []
          if (res.errno && res.errno.toString() === '0') {
            let id_arr = []
            for (let obj of res.data) {
              if (id_arr.indexOf(obj.groupId) < 0) { id_arr.push(obj.groupId) }
            }
            id_arr.sort()
            this.themeList = this.splitTheme(res.data, id_arr)
            for (let item in this.themeList) {
              this.theme.push(-1)
              // console.log(item);
            }
            // console.log(this.themeList);
          }
        })
    },
    splitTheme (themeList, id_arr) {
      // console.log(themeList, id_arr);
      const list = []
      for (let i = 0; i < id_arr.length; i++) {
        list.push([])
      }
      for (let item of themeList) {
        // list.push(themeList.slice(i, (i += num)));
        if (item.schedulingCourse) {
          item.schedulingCourse.sort(this.global.toSortKey('startTime', 1, 'string')).sort(this.global.toSortKey('date', 1, 'string'))
        }
        if (item.venueName !== '开幕式') {
          list[item.groupId - 1].push(item)
        }
      }
      for (let item of list) {
        item.sort(this.global.toSortKey('times', 1, 'string')).sort(this.global.toSortKey('date', 1, 'string'))
        // console.log(item);
      }
      return list
    },
    //
    setGroup: function (e, index, type, tindex) {
      // e.stopPropagation();
      let _this = this
      let g = this.group
      if (type === 'pc') {
        this.group = index
        this.theme_cli_pc = true
        this.theme_cli_mob = false
      } else if (type === 'mob') {
        // console.log("mob",g,this.group,index,this.theme[g],this.theme[index])
        this.theme_cli_pc = false
        this.theme_cli_mob = false
        this.theme[g] = -1
        this.$forceUpdate()
        // this.group = index;
        // this.theme_cli_mob = true;
        setTimeout(() => {
          _this.group = index
          _this.theme_cli_mob = true
          _this.$forceUpdate()
        }, 20)
        this.$forceUpdate()
      }
      // console.log('cli ', this.group, this.theme_cli_pc, this.theme_cli_mob);
    },
    toLive: function (date, group) {
      // console.log(date, group)
      this.$router.push({path: '/live', name: 'Live', query: {sid: this.global.area_id, groupid: group, time: date.toString()}})
    },
    // 时间戳->时间(xx:xx)，比较
    isTime: function (date, time1, time2) {
      let t0 = this.theTime
      let t1 = this.startTime
      let t2 = this.endTime
      let hm = this.formatTime(new Date(t0).getHours(), new Date(t0).getMinutes())
      // console.log(date, time1, time2, hm);
      // console.log(this.theTime, this.startTime, this.endTime);
      if (date) {
        if (date.toString() === t1.toString()) {
          if (this.isDate(t0, t1) && !this.isDate(t0, t2)) {
            return !!((time1 <= hm && time2 > hm))
            // (time1<=hm && time2>hm) ? (()=>{return true})() : "";
          }
        } else if (date.toString() === t2.toString()) {
          if (this.isDate(t0, t2) && !this.isDate(t0, t2 + this.timestamp)) {
            return !!((time1 <= hm && time2 > hm))
            // (time1<=hm && time2>hm) ? (()=>{return true})() : "";
          }
        }
      } else {
        if (this.isDate(t0, t1) && !this.isDate(t0, t2 + this.timestamp)) {
          return !!((time1 <= hm && time2 > hm))
        }
      }
      return false
    },
    isDate: function (date1, date2) {
      return date1 > date2
    },
    formatTime: function (hour, minute) {
      let h = hour < 10 ? '0' + hour : hour
      let m = minute < 10 ? '0' + minute : minute
      let res = h + ':' + m
      return res
    },
    // 获取指定内容时间戳 (大会、主题、专题、课程) 并与当前时间时间戳比较，theTime<res?true:false;
    getTime_: function (type, index1, index2) {
      /* type 类型   index1 主题/专题索引   index2 课程索引 */
      return this.theTime < this.setTime_(type, index1, index2)
    },
    setTime_: function (type, index1, index2) {
      // console.log(this.themeList);
      // console.log(this.theTime, this.startTime, this.endTime);
      let time = 0, theme, len, times, tlen, h, m, i1, i2, i3, i4
      if (this.themeList.length > 0) {
        // 大会开始/结束时间
        if (type === 'start' || type === 'end') {
          i1 = type === 'start' ? 0 : this.themeList.length - 1
          theme = this.themeList[i1]
          len = theme.length
          i2 = type === 'start' ? 0 : len - 1
          times = theme[i2].times.split(',')
          tlen = times.length
          i3 = type === 'start' ? 0 : tlen - 1
          i4 = type === 'start' ? 0 : 1
          h = parseInt(times[i3].split('-')[i4].split(':')[0])
          m = parseInt(times[i3].split('-')[i4].split(':')[1])
          time = (type === 'start' ? this.startTime : this.endTime) + h * 60 * 60 * 1000 + m * 60 * 1000
        } else {
          if ((type === 'group_start' || type === 'group_end') && this.themeList[index1]) {
            // 主题开始/结束时间
            theme = this.themeList[index1]
            len = theme.length
            i1 = type === 'group_start' ? (this.theTime > this.endTime ? (len - 2) : 0) : len - 1
            if (theme[i1] && theme[i1].times) {
              times = theme[i1].times.split(',')
              tlen = times.length
              i2 = type === 'group_start' ? 0 : tlen - 1
              i3 = type === 'group_start' ? 0 : 1
              h = parseInt(times[i2].split('-')[i3].split(':')[0])
              m = parseInt(times[i2].split('-')[i3].split(':')[1])
              time = (this.theTime > this.endTime ? this.endTime : this.startTime) + h * 60 * 60 * 1000 + m * 60 * 1000
            }
          } else {
            theme = this.themeList[this.group][index1]
            // 专题开始/结束时间
            if (type === 'theme_start' || type === 'theme_end') {
              times = theme.times.split(',')
              tlen = times.length
              i1 = type === 'theme_start' ? 0 : tlen - 1
              i2 = type === 'theme_start' ? 0 : 1
              h = parseInt(times[i1].split('-')[i2].split(':')[0])
              m = parseInt(times[i1].split('-')[i2].split(':')[1])
              time = theme.date * 1000 + h * 60 * 60 * 1000 + m * 60 * 1000
            }
            // 课程开始/结束时间
            if (type === 'course_start' || type === 'course_end') {
              i1 = type.split('course_')[1] + 'Time'
              h = parseInt(theme.schedulingCourse[index2][i1].split(':')[0])
              m = parseInt(theme.schedulingCourse[index2][i1].split(':')[1])
              time = theme.schedulingCourse[index2].date * 1000 + h * 60 * 60 * 1000 + m * 60 * 1000
            }
          }
        }
      }
      // console.log(time);
      return time
    }
  }
}
</script>

<style lang="scss">
.live-schedule {
  background: #fafbfc;
  padding: 0 15px;
  padding-bottom: 90px;
  h1, h2, p {
    margin-top: 0;
    margin-bottom: 0;
    text-align: left;
  }
  .wap_banner_schedule {
    h1, p {
      text-align: center;
    }
  }
  .mpd-content {
    width: 100%;
    max-width: 1345px;
    margin: 0 auto;
    margin-top: 20px;
    .load_word {
      width: 100%;
      padding: 40px 10px;
      font-size: 18px;
      font-family: Source Han Sans CN Normal;
      font-weight: 400;
      color: #999999;
      text-align: center;
    }
    .list .list-con,
    .courses .line,
    .courses .line .right .rline {
      display: flex;
      flex-wrap: nowrap;
    }
    .list {
      width: 100%;
      padding: 0 15px;
      // padding: 10px 15px;
      background: #ffffff;
      border: 1px solid #FFFFFF;
      table.list-con {
        height: 100%;
        background: linear-gradient(0deg, #FFFFFF 0%, #FFFFFF 10%, #D1D1D1 51%, #FFFFFF 90%, #FFFFFF 100%);
        tr {
          height: 100%;
          background: transparent;
          td:not(:nth-of-type(1)) {
            padding-left: 1px;
          }
          td {
            height: 100%;
            background: transparent;
            * {
              background: #FFFFFF;
            }
          }
        }
        .litem {
          // width: 20%;
          vertical-align: top;
          .head {
            width: 100%;
            height: 100%;
            padding: 0 10px;
          }
          h1 {
            height: 100%;
            // text-align: left;
          }
        }
      }
      .list-con {
        width: 100%;
        max-width: 1205px;
        margin: 0 auto;
        justify-content: space-evenly;
        display: table;
        .box {
          width: 20%;
          padding: 10px 10px;
          display: table-cell;
        }
        .box:not(:nth-of-type(1)) {
          border-left: 1px solid;
          border-image: linear-gradient(0deg, #FFFFFF 0%, #FFFFFF 25%, #D1D1D1 51%, #FFFFFF 75%, #FFFFFF 100%) 1;
        }
        .litem {
          width: 100%;
          h1 {
            width: 100%;
            padding: 0 10px;
            max-width: 190px;
            margin: 0 auto;
            margin-bottom: 0;
            line-height: 32px;
            font-size: 20px;
            font-family: Source Han Sans CN Medium;
            font-weight: 500;
            color: #242424;
            border-radius: 15px;
            text-align: center;
            cursor: pointer;
            cursor: url("../../static/images/mouse2.png"), auto !important;
          }
          p {
            margin-top: 2px;
            // margin-bottom: 0;
            // padding-top: 10px;
            line-height: 18px;
            font-size: 18px;
            font-family: Source Han Sans CN Normal;
            font-weight: 400;
            color: #999999;
            text-align: center;
          }
        }
        .litem.act {
          h1 {
            color: #FFFFFF;
            background: #E10000;
          }
          p {
            color: #E10000;
          }
        }
      }
    }
    .courses {
      width: 100%;
      margin-top: 12px;
      background: #ffffff;
      padding: 45px 15px 50px 15px;
      .line {
        width: 100%;
        max-width: 1205px;
        margin: 0 auto;
        margin-bottom: 15px;
        background: #FAFDFF;
        .left {
          width: 240px;
          min-width: 240px;
          background: #F3F5FB;
          display: table;
          vertical-align: middle;
          position: relative;
          .mark {
            top: 0;
            right: 0;
            position: absolute;
            background: transparent;
          }
          .box {
            display: table-cell;
            vertical-align: middle;
            h1 {
              line-height: 21px;
              font-size: 21px;
              font-family: PingFang SC Medium;
              font-weight: 500;
              color: #00081A;
              text-align: center;
            }
            p {
              margin-top: 10px;
              line-height: 18px;
              font-size: 18px;
              font-family: PingFang SC Regular;
              font-weight: 400;
              color: #666666;
              text-align: center;
            }
            p.time {
              font-family: PingFang SC Medium;
            }
          }
        }
        .right {
          width: 100%;
          // padding: 30px 0;
          .rline {
            width: 100%;
            padding: 30px 0;
          }
          .course:not(:nth-of-type(1)) {
            border-left: 1px solid;
            border-image: linear-gradient(0deg, #FFFFFF 0%, #D1D1D1 51%, #FFFFFF 100%) 1;
          }
          .course {
            // width: 25%;
            // min-height: 25px;
            min-height: 85px;
            padding: 0 10px;
            position: relative;
            .box:not(.none) {
              cursor: pointer;
              cursor: url("../../static/images/mouse2.png"), auto !important;
            }
            .box {
              width: 100%;
              height: 100%;
              max-width: 230px;
              margin: 0 auto;
              display: table;
              position: relative;
              z-index: 2;
              background: #FAFDFF;
              h2 {
                line-height: 22px;
                font-size: 16px;
                font-family: PingFang SC Medium;
                font-weight: 500;
                color: #3B44B9;
                text-align: left;
              }
              p {
                margin-top: 10px;
                line-height: 22px;
                font-size: 14px;
                // font-family: PingFang SC Regular;
                // font-weight: 400;
                font-family: PingFang SC Medium;
                font-weight: 500;
                color: #999999;
                text-align: left;
              }
              p.time {
                font-size: 12px;
              }
            }
            .box.none {
              max-width: 100%;
              top: 0;
              left: 0;
              z-index: 1;
              position: absolute;
              h1 {
                font-size: 20px;
                font-family: PingFang SC Medium;
                font-weight: 500;
                color: #3B44B9;
                text-align: center;
                display: table-cell;
                vertical-align: middle;
              }
            }
          }
        }
      }
      .livebtn {
        width: 100%;
        max-width: 310px;
        height: 50px;
        line-height: 50px;
        font-size: 22px;
        font-family: Source Han Sans CN Normal;
        font-weight: 400;
        color: #FFFFFF;
        text-align: center;
        border-radius: 8px;
        margin: 0 auto;
        margin-bottom: 45px;
        // margin-top: 45px;
        cursor: pointer;
        cursor: url("../../static/images/mouse2.png"), auto !important;
      }
      .livebtn.act {
        background: #C90E17;
      }
    }
  }
  .mpd-content.mob {
    .top {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      .titem {
        padding: 5px 0;
        margin-bottom: 10px;
        border-radius: 4px;
        background-color: #FFFFFF;
        .box {
          h1 {
            width: fit-content;
            // line-height: 32px;
            // font-size: 20px;
            line-height: 29px;
            font-size: 18px;
            font-family: Source Han Sans CN Medium;
            font-weight: 500;
            color: #242424;
            text-align: center;
            border-radius: 13px;
            background-color: transparent;
            margin: 0px auto;
            padding: 0 15px;
          }
          p {
            width: 100%;
            line-height: 20px;
            font-size: 12px;
            font-family: Source Han Sans CN Medium;
            font-weight: 300;
            color: #999999;
            text-align: right;
            padding-right: 5px;
          }
        }
      }
      .titem.act {
        h1 {
          color: #FFFFFF;
          background-color: #FF0000;
        }
        p {
          color: #FF0000;
        }
      }
      table {
        height: 100%;
        margin: 0 -10px;
        margin-bottom: 10px;
        tr:nth-of-type(1) td .box{
          padding: 5px 5px 0px 5px;
          // padding-top: 5px;
        }
        tr:nth-last-of-type(1) td .box{
          padding-bottom: 5px;
        }
        tr {
          height: 100%;
          td {
            height: 100%;
            border-left: 10px solid transparent;
            border-right: 10px solid transparent;
            .box {
              width: 100%;
              height: 100%;
              border-radius: 4px;
              // background-color: #FFFFFF;
              h1 {
                width: fit-content;
                max-width: 120px;
                padding: 0 10px;
                text-align: left;
              }
            }
          }
        }
      }
      table tr td, .titem {
        margin-bottom: 10px;
        border-radius: 4px;
        .box {
          h1 {
            // width: fit-content;
            height: 100%;
            word-break: break-all;
            hyphens: auto;
            line-height: 29px;
            font-size: 18px;
            // line-height: 32px;
            // font-size: 20px;
            font-family: Source Han Sans CN Medium;
            font-weight: 500;
            color: #242424;
            border-radius: 13px;
            background-color: transparent;
            margin: 0px auto;
          }
          p {
            width: 100%;
            line-height: 20px;
            font-size: 12px;
            font-family: Source Han Sans CN Medium;
            font-weight: 300;
            color: #999999;
            text-align: right;
            padding-right: 5px;
          }
        }
      }
      table tr td.act, .titem.act {
        h1 {
          color: #FFFFFF;
          background-color: #FF0000;
        }
        p {
          color: #FF0000;
        }
      }
    }
    .groups {
      width: 100%;
      margin-top: 10px;
      background: #ffffff;
      .panel, .panel-default, .panel-body {
        border: none;
      }
      .group {
        width: 100%;
        .group_head.act {
          h1, p:not(.act) {
            color: #2630b2;
            // color: #3332C8;
          }
        }
        .group_head {
          width: 100%;
          // padding: 17px 20px;
          padding: 20px;
          padding-right: 32px;
          border: 2px solid #fafbfc;
          background: #ffffff;
          position: relative;
          z-index: 20;
          cursor: pointer;
          cursor: url("../../static/images/mouse2.png"), auto !important;
          h1 {
            line-height: 18px;
            font-size: 18px;
            font-family: Source Han Sans CN Medium;
            font-weight: 500;
            color: #999999;
          }
          h2 {
            line-height: 16px;
            font-size: 16px;
            font-family: Source Han Sans CN Medium;
            font-weight: 300;
            color: #999999;
            bottom: 20px;
            right: 100px;
            position: absolute;
          }
          p {
            line-height: 13px;
            font-size: 13px;
            font-family: PingFang SC Medium;
            font-weight: 500;
            color: #cccccc;
            padding: 5px;
            bottom: 15px;
            // bottom: 20px;
            right: 40px;
            position: absolute;
            border-radius: 6px;
          }
          p.act {
            color: #FFFFFF;
            background: #FF0000;
          }
          span {
            width: 9px;
            height: 9px;
            // top: 17px;
            top: 23px;
            right: 20px;
            position: absolute;
            display: inline-block;
            border-top: 2px solid #2630b2;
            border-left: 2px solid #2630b2;
            transform: rotate(-135deg);
          }
          span.open,
          span.close {
            opacity: 1;
          }
          span.open {
            // top: 21px;
            top: 28px;
            transform: rotate(45deg);
          }
          span.close {
            border-color: #999999;
          }
        }
        .group_detail {
          width: 100%;
          .group_course {
            width: 100%;
            padding: 15px 20px;
            background: #fafdff;
            border: 2px solid #ffffff;
            position: relative;
            h1 {
              margin-top: 10px;
              margin-bottom: 0;
              line-height: 30px;
              font-size: 18px;
              font-family: PingFang SC Medium;
              font-weight: 500;
              color: #3B44B9;
            }
            p {
              margin-bottom: 0;
              margin-top: 10px;
              line-height: 16px;
              font-size: 16px;
              font-family: PingFang SC;
              font-weight: 500;
              color: #999999;
              span {
                color: #3B44B9;
              }
            }
            h2, >span {
              font-family: PingFang SC Medium;
              font-weight: 300;
            }
            h2 {
              line-height: 15px;
              font-size: 15px;
              color: #3B44B9;
            }
            >span {
              line-height: 13px;
              font-size: 13px;
              top: 15px;
              right: 20px;
              position: absolute;
            }
            >span.act {
              color: #FF0000;
            }
          }
        }
      }
    }
  }
}
@media (max-width:767px) {
  .live-schedule {
    min-height: 662px;
    padding: 0;
    padding-bottom: 60px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/LiveSchedule.vue